// src/hooks/usePageTitle.js
import { useEffect } from "react";

const SITE_NAME = "SLIIT Leo Portal 4.0";

export default function usePageTitle(pageTitle) {
  useEffect(() => {
    document.title = pageTitle ? `${pageTitle} | ${SITE_NAME}` : SITE_NAME;
  }, [pageTitle]);
}
